import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, aboutParallel, mobileAbout, mobileAboutParallel } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage
            src={mobileAboutParallel}
            w="100%"
            pv="5px"
            alt="Denji Sushi About"
          />
          <CFImage
            src={mobileAbout}
            w="100%"
            pv="5px"
            alt="Denji Sushi About"
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFImage src={about} w="100%" pv="5px" alt="Denji Sushi About" />
        <CFView
          column
          center
          maxWidth="1400px"
          m="0 auto"
          h="650px"
          image={`url(${aboutParallel}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
